import {z} from 'zod'

export const GiftCommitmentsDataSchema = z
    .object({
        campaign_goal: z.number(),
        rows: z.array(
            z
                .object({
                    gift_size: z.number(),
                    number_required: z.nullable(z.number()),
                    number_identified: z.number(),
                    sort_order: z.number(),
                })
                .transform(({gift_size, number_required, number_identified, sort_order}) => ({
                    giftSize: gift_size,
                    numberRequired: number_required,
                    numberIdentified: number_identified,
                    sortOrder: sort_order,
                })),
        ),
    })
    .transform(({campaign_goal, rows}) => ({
        campaignGoal: campaign_goal,
        rows,
    }))

export type GiftCommitmentsData = z.infer<typeof GiftCommitmentsDataSchema>
